<template>
  <div class="our-work">
    <!-- Header -->
    <vue-headful
      v-if="meta"
      :title="meta.fields['Title']"
      :description="meta.fields['Description']"
      :keywords="meta.fields['Keywords']" />
    <!-- End Header -->

    <!-- Loader -->
    <vue-element-loading
      :active="isGetCaseStudiesLoading"
      is-full-screen
      spinner="bar-fade-scale" />
    <!-- End Loader -->

    <!-- Our Work Carousel -->
    <v-container
      v-if="!isGetCaseStudiesLoading"
      style="max-width: 1000px;">
      <section
        id="header">
        <h1 class="display-3 font-weight-black my-5 mx-3">
          Our Work
        </h1>
        <v-row
          v-for="_homeCaseStudies in homeCaseStudies"
          :key="_homeCaseStudies.id"
          style="place-content: center;">
          <v-col
            v-for="homeCaseStudy in _homeCaseStudies"
            :key="homeCaseStudy.id"
            sm="4"
            cols="8">
            <router-link
              style="text-decoration: none;"
              :to="{ name: 'work', params: { slug: homeCaseStudy.fields.Slug } }">
              <v-card
                elevation="10">
                <v-img
                  v-if="(homeCaseStudy.fields.Attachments)"
                  :eager="true"
                  :src="homeCaseStudy.fields.Attachments[0].url"
                  :title="homeCaseStudy.fields.Name"
                  :alt="homeCaseStudy.fields.Name">
                  <v-card-title
                    class="fill-height align-content-end display-1 white--text ml-3 text-break">
                    {{ homeCaseStudy.fields.Name }}
                  </v-card-title>
                </v-img>
              </v-card>
            </router-link>
          </v-col>
        </v-row>
      </section>
    </v-container>
    <!-- End Our Work Carousel -->
  </div>
</template>
<script>
import VueElementLoading from 'vue-element-loading';
import axios from "axios";
import _ from "lodash";
import qs from "qs";

export default {
	name: "Works",

	components: { VueElementLoading },

	data() {
		return {
			apiUrl: this.$VUE_APP_AIRTABLE_URL,
			apiKey: this.$VUE_APP_AIRTABLE_API_KEY, // Always use a read-only account token
			apiBase: this.$VUE_APP_AIRTABLE_BASE,

			isGetCaseStudiesLoading: false,

			header: null,
			homeCaseStudies: []
		};
	},

	mounted: function() {
		this.isGetCaseStudiesLoading = true;
		this.getCaseStudies();
	},

	computed: {
		meta: function () {
			return this.$store.getters['meta/getMeta'](this.$route.path);
		},
	},

	methods: {

		getCaseStudies: function() {
			let numColumns = 3;
			axios({
				url: this.apiUrl + this.apiBase + "/HomeCaseStudies",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					sort: [ { field: "Sorting", direction: "asc" } ]
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				/* eslint-disable no-console */
				// console.log(res);
				/* eslint-enable no-console */
				// res.data.records.unshift({ isIntro: true });

				this.homeCaseStudies = _.chunk(res.data.records, numColumns);
				// console.log(this.homeCaseStudies);

				//this.homeCaseStudies = res.data.records;
			}).finally(() => {
				this.isGetCaseStudiesLoading = false;
			});
		},
	}
};
</script>
